// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Colors from "./Colors.bs.js";
import * as Global from "./Global.bs.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as ScreenAtom from "./atoms/ScreenAtom.bs.js";

var gmColor = "#" + Colors.red300;

var top50Color = "#" + Colors.green200;

var top10Color = "#" + Colors.blue200;

var top1Color = "#" + Colors.deepPurple200;

function divisionToBase(div, set) {
  if (set < 30 || set > 95) {
    switch (div) {
      case "BRONZE I" :
          return 700;
      case "BRONZE II" :
          return 600;
      case "BRONZE III" :
          return 500;
      case "BRONZE IV" :
          return 400;
      case "DIAMOND I" :
          return 2700;
      case "DIAMOND II" :
          return 2600;
      case "DIAMOND III" :
          return 2500;
      case "DIAMOND IV" :
          return 2400;
      case "EMERALD I" :
          return 2300;
      case "EMERALD II" :
          return 2200;
      case "EMERALD III" :
          return 2100;
      case "EMERALD IV" :
          return 2000;
      case "GOLD I" :
          return 1500;
      case "GOLD II" :
          return 1400;
      case "GOLD III" :
          return 1300;
      case "GOLD IV" :
          return 1200;
      case "IRON I" :
          return 300;
      case "IRON II" :
          return 200;
      case "IRON III" :
          return 100;
      case "CHALLENGER I" :
      case "GRANDMASTER I" :
      case "MASTER I" :
          return 2800;
      case "PLATINUM I" :
          return 1900;
      case "PLATINUM II" :
          return 1800;
      case "PLATINUM III" :
          return 1700;
      case "PLATINUM IV" :
          return 1600;
      case "BLUE" :
      case "GRAY" :
      case "GREEN" :
      case "IRON IV" :
      case "ORANGE" :
      case "PURPLE" :
          return 0;
      case "SILVER I" :
          return 1100;
      case "SILVER II" :
          return 1000;
      case "SILVER III" :
          return 900;
      case "SILVER IV" :
          return 800;
      default:
        return Js_exn.raiseError("Unknown league " + div);
    }
  } else {
    switch (div) {
      case "BRONZE I" :
          return 700;
      case "BRONZE II" :
          return 600;
      case "BRONZE III" :
          return 500;
      case "BRONZE IV" :
          return 400;
      case "DIAMOND I" :
          return 2300;
      case "DIAMOND II" :
          return 2200;
      case "DIAMOND III" :
          return 2100;
      case "DIAMOND IV" :
          return 2000;
      case "GOLD I" :
          return 1500;
      case "GOLD II" :
          return 1400;
      case "GOLD III" :
          return 1300;
      case "GOLD IV" :
          return 1200;
      case "IRON I" :
          return 300;
      case "IRON II" :
          return 200;
      case "IRON III" :
          return 100;
      case "CHALLENGER I" :
      case "GRANDMASTER I" :
      case "MASTER I" :
          return 2400;
      case "PLATINUM I" :
          return 1900;
      case "PLATINUM II" :
          return 1800;
      case "PLATINUM III" :
          return 1700;
      case "PLATINUM IV" :
          return 1600;
      case "BLUE" :
      case "GRAY" :
      case "GREEN" :
      case "IRON IV" :
      case "ORANGE" :
      case "PURPLE" :
          return 0;
      case "SILVER I" :
          return 1100;
      case "SILVER II" :
          return 1000;
      case "SILVER III" :
          return 900;
      case "SILVER IV" :
          return 800;
      default:
        return Js_exn.raiseError("Unknown league " + div);
    }
  }
}

function divisionToShortName(div) {
  switch (div) {
    case "BLUE" :
        return "Blue";
    case "BRONZE I" :
        return "B I";
    case "BRONZE II" :
        return "B II";
    case "BRONZE III" :
        return "B III";
    case "BRONZE IV" :
        return "B IV";
    case "CHALLENGER I" :
        return "C";
    case "DIAMOND I" :
        return "D I";
    case "DIAMOND II" :
        return "D II";
    case "DIAMOND III" :
        return "D III";
    case "DIAMOND IV" :
        return "D IV";
    case "EMERALD I" :
        return "E I";
    case "EMERALD II" :
        return "E II";
    case "EMERALD III" :
        return "E III";
    case "EMERALD IV" :
        return "E IV";
    case "GOLD I" :
        return "G I";
    case "GOLD II" :
        return "G II";
    case "GOLD III" :
        return "G III";
    case "GOLD IV" :
        return "G IV";
    case "GRANDMASTER I" :
        return "GM";
    case "GRAY" :
        return "Gray";
    case "GREEN" :
        return "Green";
    case "IRON I" :
        return "I I";
    case "IRON II" :
        return "I II";
    case "IRON III" :
        return "I III";
    case "IRON IV" :
        return "I IV";
    case "MASTER I" :
        return "M";
    case "ORANGE" :
        return "Hyper";
    case "PLATINUM I" :
        return "P I";
    case "PLATINUM II" :
        return "P II";
    case "PLATINUM III" :
        return "P III";
    case "PLATINUM IV" :
        return "P IV";
    case "PURPLE" :
        return "Purple";
    case "SILVER I" :
        return "S I";
    case "SILVER II" :
        return "S II";
    case "SILVER III" :
        return "S III";
    case "SILVER IV" :
        return "S IV";
    default:
      return Js_exn.raiseError("Unknown league " + div);
  }
}

function ratingToDivision(rating, set) {
  if (set < 30 || set > 95) {
    var base = rating / 100 | 0;
    var lp = rating >= 2800 ? rating - 2800 | 0 : rating % 100;
    var div;
    switch (base) {
      case 0 :
          div = "I IV";
          break;
      case 1 :
          div = "I III";
          break;
      case 2 :
          div = "I II";
          break;
      case 3 :
          div = "I I";
          break;
      case 4 :
          div = "B IV";
          break;
      case 5 :
          div = "B III";
          break;
      case 6 :
          div = "B II";
          break;
      case 7 :
          div = "B I";
          break;
      case 8 :
          div = "S IV";
          break;
      case 9 :
          div = "S III";
          break;
      case 10 :
          div = "S II";
          break;
      case 11 :
          div = "S I";
          break;
      case 12 :
          div = "G IV";
          break;
      case 13 :
          div = "G III";
          break;
      case 14 :
          div = "G II";
          break;
      case 15 :
          div = "G I";
          break;
      case 16 :
          div = "P IV";
          break;
      case 17 :
          div = "P III";
          break;
      case 18 :
          div = "P II";
          break;
      case 19 :
          div = "P I";
          break;
      case 20 :
          div = "E IV";
          break;
      case 21 :
          div = "E III";
          break;
      case 22 :
          div = "E II";
          break;
      case 23 :
          div = "E I";
          break;
      case 24 :
          div = "D IV";
          break;
      case 25 :
          div = "D III";
          break;
      case 26 :
          div = "D II";
          break;
      case 27 :
          div = "D I";
          break;
      default:
        div = "M";
    }
    return [
            div,
            lp
          ];
  }
  var base$1 = rating / 100 | 0;
  var lp$1 = rating >= 2400 ? rating - 2400 | 0 : rating % 100;
  var div$1;
  switch (base$1) {
    case 0 :
        div$1 = "I IV";
        break;
    case 1 :
        div$1 = "I III";
        break;
    case 2 :
        div$1 = "I II";
        break;
    case 3 :
        div$1 = "I I";
        break;
    case 4 :
        div$1 = "B IV";
        break;
    case 5 :
        div$1 = "B III";
        break;
    case 6 :
        div$1 = "B II";
        break;
    case 7 :
        div$1 = "B I";
        break;
    case 8 :
        div$1 = "S IV";
        break;
    case 9 :
        div$1 = "S III";
        break;
    case 10 :
        div$1 = "S II";
        break;
    case 11 :
        div$1 = "S I";
        break;
    case 12 :
        div$1 = "G IV";
        break;
    case 13 :
        div$1 = "G III";
        break;
    case 14 :
        div$1 = "G II";
        break;
    case 15 :
        div$1 = "G I";
        break;
    case 16 :
        div$1 = "P IV";
        break;
    case 17 :
        div$1 = "P III";
        break;
    case 18 :
        div$1 = "P II";
        break;
    case 19 :
        div$1 = "P I";
        break;
    case 20 :
        div$1 = "D IV";
        break;
    case 21 :
        div$1 = "D III";
        break;
    case 22 :
        div$1 = "D II";
        break;
    case 23 :
        div$1 = "D I";
        break;
    default:
      div$1 = "M";
  }
  return [
          div$1,
          lp$1
        ];
}

function ratingToDivisionFull(rating, set) {
  if (set > 95 || set < 30) {
    var base = rating / 100 | 0;
    var lp = rating >= 2800 ? rating - 2800 | 0 : rating % 100;
    var div;
    switch (base) {
      case 0 :
          div = "Iron IV";
          break;
      case 1 :
          div = "Iron III";
          break;
      case 2 :
          div = "Iron II";
          break;
      case 3 :
          div = "Iron I";
          break;
      case 4 :
          div = "Bronze IV";
          break;
      case 5 :
          div = "Bronze III";
          break;
      case 6 :
          div = "Bronze II";
          break;
      case 7 :
          div = "Bronze I";
          break;
      case 8 :
          div = "Silver IV";
          break;
      case 9 :
          div = "Silver III";
          break;
      case 10 :
          div = "Silver II";
          break;
      case 11 :
          div = "Silver I";
          break;
      case 12 :
          div = "Gold IV";
          break;
      case 13 :
          div = "Gold III";
          break;
      case 14 :
          div = "Gold II";
          break;
      case 15 :
          div = "Gold I";
          break;
      case 16 :
          div = "Platinum IV";
          break;
      case 17 :
          div = "Platinum III";
          break;
      case 18 :
          div = "Platinum II";
          break;
      case 19 :
          div = "Platinum I";
          break;
      case 20 :
          div = "Emerald IV";
          break;
      case 21 :
          div = "Emerald III";
          break;
      case 22 :
          div = "Emerald II";
          break;
      case 23 :
          div = "Emerald I";
          break;
      case 24 :
          div = "Diamond IV";
          break;
      case 25 :
          div = "Diamond III";
          break;
      case 26 :
          div = "Diamond II";
          break;
      case 27 :
          div = "Diamond I";
          break;
      default:
        div = "Master";
    }
    return [
            div,
            lp
          ];
  }
  var base$1 = rating / 100 | 0;
  var lp$1 = rating >= 2400 ? rating - 2400 | 0 : rating % 100;
  var div$1;
  switch (base$1) {
    case 0 :
        div$1 = "Iron IV";
        break;
    case 1 :
        div$1 = "Iron III";
        break;
    case 2 :
        div$1 = "Iron II";
        break;
    case 3 :
        div$1 = "Iron I";
        break;
    case 4 :
        div$1 = "Bronze IV";
        break;
    case 5 :
        div$1 = "Bronze III";
        break;
    case 6 :
        div$1 = "Bronze II";
        break;
    case 7 :
        div$1 = "Bronze I";
        break;
    case 8 :
        div$1 = "Silver IV";
        break;
    case 9 :
        div$1 = "Silver III";
        break;
    case 10 :
        div$1 = "Silver II";
        break;
    case 11 :
        div$1 = "Silver I";
        break;
    case 12 :
        div$1 = "Gold IV";
        break;
    case 13 :
        div$1 = "Gold III";
        break;
    case 14 :
        div$1 = "Gold II";
        break;
    case 15 :
        div$1 = "Gold I";
        break;
    case 16 :
        div$1 = "Platinum IV";
        break;
    case 17 :
        div$1 = "Platinum III";
        break;
    case 18 :
        div$1 = "Platinum II";
        break;
    case 19 :
        div$1 = "Platinum I";
        break;
    case 20 :
        div$1 = "Diamond IV";
        break;
    case 21 :
        div$1 = "Diamond III";
        break;
    case 22 :
        div$1 = "Diamond II";
        break;
    case 23 :
        div$1 = "Diamond I";
        break;
    default:
      div$1 = "Master";
  }
  return [
          div$1,
          lp$1
        ];
}

function renderDivisionName(div) {
  switch (div) {
    case "BLUE" :
        return "Blue";
    case "BRONZE I" :
        return "Bronze I";
    case "BRONZE II" :
        return "Bronze II";
    case "BRONZE III" :
        return "Bronze III";
    case "BRONZE IV" :
        return "Bronze IV";
    case "CHALLENGER I" :
        return "Challenger";
    case "DIAMOND I" :
        return "Diamond I";
    case "DIAMOND II" :
        return "Diamond II";
    case "DIAMOND III" :
        return "Diamond III";
    case "DIAMOND IV" :
        return "Diamond IV";
    case "EMERALD I" :
        return "Emerald I";
    case "EMERALD II" :
        return "Emerald II";
    case "EMERALD III" :
        return "Emerald III";
    case "EMERALD IV" :
        return "Emerald IV";
    case "GOLD I" :
        return "Gold I";
    case "GOLD II" :
        return "Gold II";
    case "GOLD III" :
        return "Gold III";
    case "GOLD IV" :
        return "Gold IV";
    case "GRANDMASTER I" :
        return "Grandmaster";
    case "GRAY" :
        return "Gray";
    case "GREEN" :
        return "Green";
    case "IRON I" :
        return "Iron I";
    case "IRON II" :
        return "Iron II";
    case "IRON III" :
        return "Iron III";
    case "IRON IV" :
        return "Iron IV";
    case "MASTER I" :
        return "Master";
    case "ORANGE" :
        return "Hyper";
    case "PLATINUM I" :
        return "Platinum I";
    case "PLATINUM II" :
        return "Platinum II";
    case "PLATINUM III" :
        return "Platinum III";
    case "PLATINUM IV" :
        return "Platinum IV";
    case "PURPLE" :
        return "Purple";
    case "SILVER I" :
        return "Silver I";
    case "SILVER II" :
        return "Silver II";
    case "SILVER III" :
        return "Silver III";
    case "SILVER IV" :
        return "Silver IV";
    default:
      return "???";
  }
}

function unrenderDivisionName(div) {
  switch (div) {
    case "Bronze I" :
        return "BRONZE I";
    case "Bronze II" :
        return "BRONZE II";
    case "Bronze III" :
        return "BRONZE III";
    case "Bronze IV" :
        return "BRONZE IV";
    case "Challenger" :
        return "CHALLENGER I";
    case "Diamond I" :
        return "DIAMOND I";
    case "Diamond II" :
        return "DIAMOND II";
    case "Diamond III" :
        return "DIAMOND III";
    case "Diamond IV" :
        return "DIAMOND IV";
    case "Emerald I" :
        return "EMERALD I";
    case "Emerald II" :
        return "EMERALD II";
    case "Emerald III" :
        return "EMERALD III";
    case "Emerald IV" :
        return "EMERALD IV";
    case "Gold I" :
        return "GOLD I";
    case "Gold II" :
        return "GOLD II";
    case "Gold III" :
        return "GOLD III";
    case "Gold IV" :
        return "GOLD IV";
    case "Grandmaster" :
        return "GRANDMASTER I";
    case "Iron I" :
        return "IRON I";
    case "Iron II" :
        return "IRON II";
    case "Iron III" :
        return "IRON III";
    case "Iron IV" :
        return "IRON IV";
    case "Master" :
        return "MASTER I";
    case "Platinum I" :
        return "PLATINUM I";
    case "Platinum II" :
        return "PLATINUM II";
    case "Platinum III" :
        return "PLATINUM III";
    case "Platinum IV" :
        return "PLATINUM IV";
    case "Silver I" :
        return "SILVER I";
    case "Silver II" :
        return "SILVER II";
    case "Silver III" :
        return "SILVER III";
    case "Silver IV" :
        return "SILVER IV";
    default:
      throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
              "LpChartUtils.res",
              362,
              9
            ],
            Error: new Error()
          };
  }
}

function renderDivisionNameShort(div) {
  switch (div) {
    case "BRONZE I" :
        return "B I";
    case "BRONZE II" :
        return "B II";
    case "BRONZE III" :
        return "B III";
    case "BRONZE IV" :
        return "B IV";
    case "CHALLENGER I" :
        return "C";
    case "DIAMOND I" :
        return "D I";
    case "DIAMOND II" :
        return "D II";
    case "DIAMOND III" :
        return "D III";
    case "DIAMOND IV" :
        return "D IV";
    case "EMERALD I" :
        return "E I";
    case "EMERALD II" :
        return "E II";
    case "EMERALD III" :
        return "E III";
    case "EMERALD IV" :
        return "E IV";
    case "GOLD I" :
        return "G I";
    case "GOLD II" :
        return "G II";
    case "GOLD III" :
        return "G III";
    case "GOLD IV" :
        return "G IV";
    case "GRANDMASTER I" :
        return "GM";
    case "IRON I" :
        return "I I";
    case "IRON II" :
        return "I II";
    case "IRON III" :
        return "I III";
    case "IRON IV" :
        return "I IV";
    case "MASTER I" :
        return "M";
    case "PLATINUM I" :
        return "P I";
    case "PLATINUM II" :
        return "P II";
    case "PLATINUM III" :
        return "P III";
    case "PLATINUM IV" :
        return "P IV";
    case "SILVER I" :
        return "S I";
    case "SILVER II" :
        return "S II";
    case "SILVER III" :
        return "S III";
    case "SILVER IV" :
        return "S IV";
    default:
      console.log("Unknown division", div);
      return "?";
  }
}

function getYTicks(minStatsRank, maxStatsRank) {
  var fullDelta = maxStatsRank - minStatsRank | 0;
  var increment = fullDelta > 5000 ? 1000 : (
      fullDelta > 1500 ? 500 : (
          fullDelta > 550 ? 200 : 100
        )
    );
  var minRank = minStatsRank - Caml_int32.mod_(minStatsRank, increment) | 0;
  var maxRank = (maxStatsRank + (increment - Caml_int32.mod_(maxStatsRank, increment) | 0) | 0) + 1 | 0;
  var currRank = Caml_int32.mod_(minRank, increment) === 0 ? minRank : minRank + (increment - Caml_int32.mod_(minRank, increment) | 0) | 0;
  var ticks = [];
  while(currRank < maxRank) {
    ticks.push(currRank);
    currRank = currRank + increment | 0;
  };
  var minRank$1 = (minStatsRank - minRank | 0) < (increment / 4 | 0) ? minRank - (increment / 4 | 0) | 0 : minRank;
  var maxRank$1 = (maxRank - maxStatsRank | 0) < (increment / 4 | 0) ? maxRank + (increment / 4 | 0) | 0 : maxRank;
  return [
          ticks,
          minRank$1,
          maxRank$1
        ];
}

var patchDays = [
  [
    "2020-01-08",
    "10.1"
  ],
  [
    "2020-01-23",
    "10.2"
  ],
  [
    "2020-02-05",
    "10.3"
  ],
  [
    "2020-02-20",
    "10.4"
  ],
  [
    "2020-03-04",
    "10.5"
  ],
  [
    "2020-03-18",
    "10.6"
  ],
  [
    "2020-04-01",
    "10.7"
  ],
  [
    "2020-04-15",
    "10.8"
  ],
  [
    "2020-04-29",
    "10.9"
  ],
  [
    "2020-05-13",
    "10.10"
  ],
  [
    "2020-05-28",
    "10.11"
  ],
  [
    "2020-06-10",
    "10.12"
  ],
  [
    "2020-06-24",
    "10.13"
  ],
  [
    "2020-07-08",
    "10.14"
  ],
  [
    "2020-07-22",
    "10.15"
  ],
  [
    "2020-08-05",
    "10.16"
  ],
  [
    "2020-08-19",
    "10.17"
  ],
  [
    "2020-09-02",
    "10.18"
  ],
  [
    "2020-09-16",
    "10.19"
  ],
  [
    "2020-09-30",
    "10.20"
  ],
  [
    "2020-10-14",
    "10.21"
  ],
  [
    "2020-10-28",
    "10.22"
  ],
  [
    "2020-11-11",
    "10.23"
  ],
  [
    "2020-11-24",
    "10.24"
  ],
  [
    "2020-12-09",
    "10.25"
  ],
  [
    "2021-01-06",
    "11.1"
  ],
  [
    "2021-01-21",
    "11.2"
  ],
  [
    "2021-02-03",
    "11.3"
  ],
  [
    "2021-02-18",
    "11.4"
  ],
  [
    "2021-03-03",
    "11.5"
  ],
  [
    "2021-03-17",
    "11.6"
  ],
  [
    "2021-03-31",
    "11.7"
  ],
  [
    "2021-04-14",
    "11.8"
  ],
  [
    "2021-04-28",
    "11.9"
  ],
  [
    "2021-05-12",
    "11.10"
  ],
  [
    "2021-05-26",
    "11.11"
  ],
  [
    "2021-06-09",
    "11.12"
  ],
  [
    "2021-06-23",
    "11.13"
  ],
  [
    "2021-07-08",
    "11.14"
  ],
  [
    "2021-07-21",
    "11.15"
  ],
  [
    "2021-08-11",
    "11.16"
  ],
  [
    "2021-08-25",
    "11.17"
  ],
  [
    "2021-09-09",
    "11.18"
  ],
  [
    "2021-09-22",
    "11.19"
  ],
  [
    "2021-10-06",
    "11.20"
  ],
  [
    "2021-10-20",
    "11.21"
  ],
  [
    "2021-11-03",
    "11.22"
  ],
  [
    "2021-11-17",
    "11.23"
  ],
  [
    "2021-12-08",
    "11.24"
  ],
  [
    "2022-01-05",
    "12.1"
  ],
  [
    "2022-01-20",
    "12.2"
  ],
  [
    "2022-02-02",
    "12.3"
  ],
  [
    "2022-02-16",
    "12.4"
  ],
  [
    "2022-03-02",
    "12.5"
  ],
  [
    "2022-03-30",
    "12.6"
  ],
  [
    "2022-04-13",
    "12.7"
  ],
  [
    "2022-04-27",
    "12.8"
  ],
  [
    "2022-05-11",
    "12.9"
  ],
  [
    "2022-05-25",
    "12.10"
  ],
  [
    "2022-06-08",
    "12.11"
  ],
  [
    "2022-06-23",
    "12.12"
  ],
  [
    "2022-07-13",
    "12.13"
  ],
  [
    "2022-07-27",
    "12.14"
  ],
  [
    "2022-08-10",
    "12.15"
  ],
  [
    "2022-08-24",
    "12.16"
  ],
  [
    "2022-09-08",
    "12.17"
  ],
  [
    "2022-09-21",
    "12.18"
  ],
  [
    "2022-10-05",
    "12.19"
  ],
  [
    "2022-10-19",
    "12.20"
  ],
  [
    "2022-11-02",
    "12.21"
  ],
  [
    "2022-11-16",
    "12.22"
  ],
  [
    "2022-12-07",
    "12.23"
  ],
  [
    "2023-01-11",
    "13.1"
  ],
  [
    "2023-01-25",
    "13.2"
  ],
  [
    "2023-02-08",
    "13.3"
  ],
  [
    "2023-02-23",
    "13.4"
  ],
  [
    "2023-03-08",
    "13.5"
  ],
  [
    "2023-03-22",
    "13.6"
  ],
  [
    "2023-04-05",
    "13.7"
  ],
  [
    "2023-04-19",
    "13.8"
  ],
  [
    "2023-05-03",
    "13.9"
  ],
  [
    "2023-05-17",
    "13.10"
  ],
  [
    "2023-06-01",
    "13.11"
  ],
  [
    "2023-06-14",
    "13.12"
  ],
  [
    "2023-06-28",
    "13.13"
  ],
  [
    "2023-07-19",
    "13.14"
  ],
  [
    "2023-08-02",
    "13.15"
  ],
  [
    "2023-08-16",
    "13.16"
  ],
  [
    "2023-08-30",
    "13.17"
  ],
  [
    "2023-09-13",
    "13.18"
  ],
  [
    "2023-09-27",
    "13.19"
  ],
  [
    "2023-10-11",
    "13.20"
  ],
  [
    "2023-10-25",
    "13.21"
  ],
  [
    "2023-11-08",
    "13.22"
  ],
  [
    "2023-11-21",
    "13.23"
  ],
  [
    "2023-12-06",
    "13.24"
  ],
  [
    "2024-01-10",
    "14.1"
  ],
  [
    "2024-01-24",
    "14.2"
  ],
  [
    "2024-02-06",
    "14.3"
  ],
  [
    "2024-02-22",
    "14.4"
  ],
  [
    "2024-03-06",
    "14.5"
  ],
  [
    "2024-03-20",
    "14.6"
  ],
  [
    "2024-04-03",
    "14.7"
  ],
  [
    "2024-04-17",
    "14.8"
  ],
  [
    "2024-05-01",
    "14.9"
  ],
  [
    "2024-05-15",
    "14.10"
  ],
  [
    "2024-05-30",
    "14.11"
  ],
  [
    "2024-06-12",
    "14.12"
  ],
  [
    "2024-06-26",
    "14.13"
  ],
  [
    "2024-07-17",
    "14.14"
  ],
  [
    "2024-07-31",
    "14.15"
  ],
  [
    "2024-08-14",
    "14.16"
  ],
  [
    "2024-08-28",
    "14.17"
  ],
  [
    "2024-09-11",
    "14.18"
  ],
  [
    "2024-09-25",
    "14.19"
  ],
  [
    "2024-10-09",
    "14.20"
  ],
  [
    "2024-10-23",
    "14.21"
  ],
  [
    "2024-11-06",
    "14.22"
  ],
  [
    "2024-11-20",
    "14.23"
  ],
  [
    "2024-12-11",
    "14.24"
  ],
  [
    "2025-01-09",
    "15.1"
  ],
  [
    "2025-01-23",
    "15.2"
  ],
  [
    "2025-02-05",
    "15.3"
  ],
  [
    "2025-02-20",
    "15.4"
  ],
  [
    "2025-03-05",
    "15.5"
  ],
  [
    "2025-03-19",
    "15.6"
  ],
  [
    "2025-04-02",
    "15.7"
  ],
  [
    "2025-04-16",
    "15.8"
  ],
  [
    "2025-04-30",
    "15.9"
  ],
  [
    "2025-05-14",
    "15.10"
  ],
  [
    "2025-05-28",
    "15.11"
  ],
  [
    "2025-06-11",
    "15.12"
  ],
  [
    "2025-06-25",
    "15.13"
  ],
  [
    "2025-07-16",
    "15.14"
  ],
  [
    "2025-07-30",
    "15.15"
  ],
  [
    "2025-08-13",
    "15.16"
  ],
  [
    "2025-08-27",
    "15.17"
  ],
  [
    "2025-09-10",
    "15.18"
  ],
  [
    "2025-09-24",
    "15.19"
  ],
  [
    "2025-10-08",
    "15.20"
  ],
  [
    "2025-10-22",
    "15.21"
  ],
  [
    "2025-11-05",
    "15.22"
  ],
  [
    "2025-11-19",
    "15.23"
  ],
  [
    "2025-12-10",
    "15.24"
  ],
  [
    "2025-12-17",
    "15.25"
  ]
];

var newPatchDays = [
  [
    "2024-11-20",
    "13.1"
  ],
  [
    "2024-12-11",
    "13.2"
  ],
  [
    "2025-01-09",
    "13.3"
  ],
  [
    "2025-01-23",
    "13.4"
  ],
  [
    "2025-02-05",
    "13.5"
  ],
  [
    "2025-02-20",
    "13.6"
  ],
  [
    "2025-03-05",
    "13.7"
  ],
  [
    "2025-03-19",
    "13.8"
  ],
  [
    "2025-04-02",
    "14.1"
  ],
  [
    "2025-04-16",
    "14.2"
  ],
  [
    "2025-04-30",
    "14.3"
  ],
  [
    "2025-05-14",
    "14.4"
  ],
  [
    "2025-05-28",
    "14.5"
  ],
  [
    "2025-06-11",
    "14.6"
  ],
  [
    "2025-06-25",
    "14.7"
  ],
  [
    "2025-07-16",
    "14.8"
  ],
  [
    "2025-07-30",
    "15.1"
  ],
  [
    "2025-08-13",
    "15.2"
  ],
  [
    "2025-08-27",
    "15.3"
  ],
  [
    "2025-09-10",
    "15.4"
  ],
  [
    "2025-09-24",
    "15.5"
  ],
  [
    "2025-10-08",
    "15.6"
  ],
  [
    "2025-10-22",
    "15.7"
  ],
  [
    "2025-11-05",
    "15.8"
  ],
  [
    "2025-11-19",
    "16.1"
  ],
  [
    "2025-12-10",
    "16.2"
  ],
  [
    "2025-12-17",
    "16.3"
  ]
];

function showTop1(region) {
  return false;
}

function showTop10(region) {
  return false;
}

function showTop25(region) {
  if (region >= 12) {
    return false;
  }
  switch (region) {
    case /* Euw */0 :
    case /* Me */5 :
    case /* Ru */8 :
    case /* Kr */9 :
    case /* Jp */10 :
        return false;
    case /* Eune */1 :
    case /* Na */2 :
    case /* Lan */3 :
    case /* Las */4 :
    case /* Oce */6 :
    case /* Tr */7 :
    case /* Br */11 :
        return true;
    
  }
}

function showTop50(region) {
  if (region !== 9) {
    return region === 0;
  } else {
    return true;
  }
}

function tickLabelPropsLeft(screenSize, set, v) {
  var fill = set < 30 || set > 95 ? (
      v > 2800 ? "var(--white1)" : (
          v === 2800 ? "#" + Colors.master : (
              v >= 2400 ? "#" + Colors.diamond : (
                  v >= 2000 ? "#" + Colors.emerald : (
                      v >= 1600 ? "#" + Colors.platinum : (
                          v >= 1200 ? "#" + Colors.gold : (
                              v >= 800 ? "#" + Colors.silver : (
                                  v >= 400 ? "#" + Colors.bronze : "#" + Colors.iron
                                )
                            )
                        )
                    )
                )
            )
        )
    ) : (
      v > 2400 ? "var(--white1)" : (
          v === 2400 ? "#" + Colors.master : (
              v >= 2000 ? "#" + Colors.diamond : (
                  v >= 1600 ? "#" + Colors.platinum : (
                      v >= 1200 ? "#" + Colors.gold : (
                          v >= 800 ? "#" + Colors.silver : (
                              v >= 400 ? "#" + Colors.bronze : "#" + Colors.iron
                            )
                        )
                    )
                )
            )
        )
    );
  return {
          fill: fill,
          textAnchor: "end",
          fontSize: ScreenAtom.isMobile(screenSize) ? 10 : 12,
          fontFamily: "Roboto",
          dx: "-0.25em",
          dy: "0.25em"
        };
}

function tickLabelPropsLeftBase(screenSize, param) {
  return {
          fill: "var(--white1)",
          textAnchor: "end",
          fontSize: ScreenAtom.isMobile(screenSize) ? 10 : 12,
          fontFamily: "Roboto",
          dx: "-0.25em",
          dy: "0.25em"
        };
}

function tickLabelPropsBottom(screenSize, param) {
  return {
          fill: "var(--white1)",
          textAnchor: "middle",
          fontSize: ScreenAtom.isMobile(screenSize) ? 10 : 12,
          fontFamily: "Roboto",
          dy: "0.25em"
        };
}

function rankAlpha(rank, alpha) {
  switch (rank) {
    case /* Challenger */0 :
        return "rgba(245, 212, 38, " + Global.toFixed(undefined, alpha) + ")";
    case /* Grandmaster */1 :
        return "rgba(206, 64, 57, " + Global.toFixed(undefined, alpha) + ")";
    case /* Master */2 :
        return "rgba(237, 94, 186, " + Global.toFixed(undefined, alpha) + ")";
    case /* Diamond */3 :
        return "rgba(109, 157, 255, " + Global.toFixed(undefined, alpha) + ")";
    
  }
}

var rankColor = "var(--primary-11)";

var rankColorFaded = "rgba(128, 203, 196, 0.87)";

var challColor = "yellow";

export {
  rankColor ,
  rankColorFaded ,
  gmColor ,
  challColor ,
  top50Color ,
  top10Color ,
  top1Color ,
  divisionToBase ,
  divisionToShortName ,
  ratingToDivision ,
  ratingToDivisionFull ,
  renderDivisionName ,
  unrenderDivisionName ,
  renderDivisionNameShort ,
  getYTicks ,
  patchDays ,
  newPatchDays ,
  showTop1 ,
  showTop10 ,
  showTop25 ,
  showTop50 ,
  tickLabelPropsLeft ,
  tickLabelPropsLeftBase ,
  tickLabelPropsBottom ,
  rankAlpha ,
  
}
/* Colors Not a pure module */
